// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"SuperZoomImage_imageWrapper__h4WIL","image":"SuperZoomImage_image__k5Cit"};